import { useRef } from 'react';
import cn from 'classnames';
import Link from 'next/link';

import MillionsIcon, { IconNames } from 'ui3/MillionsIcon/MillionsIcon';

import styles from './Dropdown.module.scss';
import { useState } from 'react';
import { useOutsideClick } from 'hooks';

type DropdownProps = {
  label: string;
  options: {
    label: string;
    url?: string;
    internalLink?: boolean;
    onClick?: () => void;
    icon?: IconNames;
  }[];
  className?: string;
};

const Dropdown = ({ label, options, className }: DropdownProps) => {
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [optionsListIsVisible, setOptionsListIsVisible] = useState<boolean>(
    false
  );

  useOutsideClick(dropdownRef, () => {
    setOptionsListIsVisible(false);
  });

  const toggleList = () => {
    setOptionsListIsVisible((prev) => !prev);
  };

  return (
    <div className={cn(styles.root, className)} ref={dropdownRef}>
      <button className={styles.button} onClick={toggleList}>
        {label} <MillionsIcon name="chevronDown" className={styles.icon} />
      </button>

      <ul
        aria-hidden={!optionsListIsVisible}
        className={cn(styles.optionsList, {
          [styles.visible]: optionsListIsVisible,
        })}
      >
        {options.map((option) => {
          const content = (
            <>
              {option.icon && (
                <MillionsIcon
                  name={option.icon}
                  size={20}
                  className={styles.optionIcon}
                />
              )}
              {option.label}
            </>
          );

          return (
            <li key={option.label} className={styles.option}>
              {option.url ? (
                option.internalLink ? (
                  <Link href={option.url} passHref>
                    <a>{content}</a>
                  </Link>
                ) : (
                  <a href={option.url}>{content}</a>
                )
              ) : (
                <button onClick={option.onClick}>{content}</button>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Dropdown;
